//@ts-check
import React from 'react';
import FormButtons from './FormButtons';
import useFormLayout from '../layout/useFormLayout';
import useFormDataLayer from '../logic/useFormDataLayer';

var ConnectedFormButtons = function ConnectedFormButtons(props) {
  var onSubmit = props.onSubmit,
      disableSubmitButton = props.disableSubmitButton;
  var hideSubmitButton = props.hideSubmitButton,
      submitButtonContent = props.submitButtonContent;
  var backButtonContent = props.backButtonContent,
      continueButtonContent = props.continueButtonContent;

  var _useFormDataLayer = useFormDataLayer('FORM_PAGES_FIELD'),
      pageId = _useFormDataLayer.value,
      dispatch = _useFormDataLayer.dispatch;

  var _useFormLayout = useFormLayout(),
      pages = _useFormLayout.pages;

  return React.createElement(FormButtons, {
    pages: pages,
    pageId: pageId,
    dispatch: dispatch,
    onSubmit: onSubmit,
    hideSubmitButton: hideSubmitButton,
    disableSubmitButton: disableSubmitButton,
    backButtonContent: backButtonContent,
    continueButtonContent: continueButtonContent,
    submitButtonContent: submitButtonContent
  });
};

export default ConnectedFormButtons;